<template>
  <div class="info">
    <div class="info-box">
      <div class="info-left">
        <div class="info-title">{{newsList.title}}</div>
        <div class="info-brief">
          <div class="create-time">{{newsList.create_time | dateformat('YYYY-MM-DD HH:mm:ss')}}</div>
          <div class="views">
            <!-- <img src="@img/eye.png" alt> <span>{{newsList.viewer_num}}人已查看</span>  -->
          </div>
        </div>
        <div class="info-text" v-html="newsList.content"></div>
      </div>
      <!-- <div class="info-right">
        <div class="title">相关资讯</div>
        <div class="cards" v-for="(item,index) in lateList " :key="index">
          <img :src="item.img_url" alt>
          <a href="javascript:" @click="toInfoDes(item.id)">{{item.title}}</a>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import {getCookie, group_sign } from '../../utils/tool'
export default {
  data() {
    return {
      newsList: [],
      lateList: [],
    };
  },
  methods: {
    getNewsData(id) {
      let that = this;
      var param = group_sign({news_id: Number(id)})
      this.$axios.post(this.$Api.apiGetNewsById, param).then(
        res => {
          that.newsList = res.data.result
          that.newsList.content = that.htmlDecode(that.newsList.content)
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");});
    },
    htmlDecode(str) {
      var s = "";
      if (str.length === 0) return "暂无课程详情";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&#39;/g, '"');
      s = s.replace(/&quot;/g, '"');
      return s;
    },
    getLateNews(kind_id) {
      let that = this;
      var param = group_sign({account_id: that.account_id,kind_id: kind_id,page_size:50})
      this.$axios.post(this.$Api.apiGetNewsKind, param).then(
        res => {
          that.lateList = res.data.result.news;
        }
      ).catch(error => {console.log(error, ">>>>>>>>>");});
      // return new Promise((resolve, reject) => {
      //   apiQueryLatesNews()
      //     .then(res => {
      //       that.lateList = res.result.list;
      //     })
      //     .catch(error => {});
      // });
    },
    toInfoDes(id) {
      this.$router.push({
        path: "/page/info_details",
        query: { id: id }
      });
      this.getNewsData(id);
    }
  },
  beforeMount() {
    let id = this.$route.query.id;
    let kindId = this.$route.query.kind_id
    this.getNewsData(id);
    this.getLateNews(kindId);
  },
  updated() {
    $('.info-text').find('img').css('maxWidth', '100%');
 },
};
</script>
<style lang="less" scoped>
@import url('../../assets/less/infoDetail.less');
</style>
